module.exports = __webpack_public_path__ + "static/img/shanghai3.fe9699c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/homePortal/shanghai3.jpg
// module id = 5RjI
// module chunks = 1